export default "__VITE_ASSET__D9A2IeMt__"